import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { lazy } from 'react';
import Plugin from '@jbrowse/core/Plugin';
import UCSCTrackHubConnectionF from './ucsc-trackhub';
import AddTrackWidgetF from './AddTrackWidget';
import AddConnectionWidgetF from './AddConnectionWidget';
import PluginStoreWidgetF from './PluginStoreWidget';
import HierarchicalTrackSelectorWidgetF from './HierarchicalTrackSelectorWidget';
var SetDefaultSession = lazy(function () {
  return import('./SetDefaultSession');
});
var AssemblyManager = lazy(function () {
  return import('./AssemblyManager');
});
var _default = /*#__PURE__*/function (_Plugin) {
  _inherits(_default, _Plugin);
  function _default() {
    var _this;
    _classCallCheck(this, _default);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(_default).apply(this, arguments));
    _this.name = 'DataManagementPlugin';
    _this.exports = {
      AssemblyManager: AssemblyManager,
      SetDefaultSession: SetDefaultSession
    };
    return _this;
  }
  _createClass(_default, [{
    key: "install",
    value: function install(pluginManager) {
      UCSCTrackHubConnectionF(pluginManager);
      AddTrackWidgetF(pluginManager);
      HierarchicalTrackSelectorWidgetF(pluginManager);
      AddConnectionWidgetF(pluginManager);
      PluginStoreWidgetF(pluginManager);
    }
  }, {
    key: "configure",
    value: function configure(_pluginManager) {}
  }]);
  return _default;
}(Plugin);
export { _default as default };
export { AssemblyManager, SetDefaultSession };